import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';

@Component({
	selector: 'app-sub-nav',
	styleUrls: ['./sub-nav.component.css'],
	templateUrl: './sub-nav.component.html'
})
export class SubNavComponent implements OnInit {
	@Input() widgets: string;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() navigateToWidgetSlide = new EventEmitter<any>();

	public widgetNavItems = [];
	private activeIndex = 0;

	constructor() {
		EmitterService.get(EVENT_EMITTERS.SET_ACTIVE_STATE_TO_CURRENT_SLIDE).subscribe((response: any) => {
			this.activeIndex = response.index;
		});
	}

	ngOnInit(): void {
		this.widgetNavItems = decodeURI(this.widgets).split(',');
	}

	navigateToWidget(index: any, widget: any): void {
		this.activeIndex = index;
		EmitterService.get(EVENT_EMITTERS.NAVIGATE_TO_SLIDE).emit({ index, widget });
	}
}
